module.exports = __webpack_public_path__ + "kudos_9.svg?e098f7db7bdcd2f70a222f1605ec2d26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_9.svg
// module id = 192
// module chunks = 0